import React, { useEffect, useRef } from "react";
import { Collapse } from "bootstrap";
import {Link} from "react-router-dom";

const Accordion = ({ data, headerKey, contentKeys, headerLocation }) => {
	const entryAccordion = useRef(null);

	useEffect(() => {
		if (entryAccordion.current !== null) {
			const collapses = entryAccordion.current.querySelectorAll(".accordion-collapse");
			collapses.forEach((collapseElement) => {
				new Collapse(collapseElement, {
					toggle: false,
				});
			});
		}
	}, [data]);

	const formatTitle = (title) => {
		return title.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
	};

	return (
		<div className="entry-accordion form-group" id="accordionExample" ref={entryAccordion}>
			{data.map((entry, index) => (
				<div className="entry-accordion-item" key={index}>
					<div className="entry-accordion-header" id={`heading${index}`}>
						<div className="entry-accordion-field entry-accordion-field--border d-flex justify-content-between align-items-end">
							<div>
								<strong className="entry-accordion-field__title">{formatTitle(headerKey)}</strong>
								<Link to={`${headerLocation}/${entry.id}`}>
									{entry[headerKey]}
								</Link>
							</div>
							<button
								className={`btn btn-accordion-toggle ${index > 0 ? 'collapsed' : ''}`}
								type="button"
								data-bs-toggle="collapse"
								data-bs-target={`#collapse-${index}`}
								aria-expanded={false}
								aria-controls={`collapse-${index}`}
							>
							</button>
						</div>
					</div>
					<div id={`collapse-${index}`}
						 className={`accordion-collapse collapse`}
						 data-bs-parent="#accordionExample">
					<div className="accordion-body">
							{contentKeys.map((key) => {
								return (
									<div className="entry-accordion-field entry-accordion-field--border">
										<span key={key}><strong className="entry-accordion-field__title">{formatTitle(key)}:</strong> {entry[key]}</span>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default Accordion;
